import { MutationCache, QueryClient } from '@tanstack/react-query';
import { ApiError, errorMessage } from '@/shared/api';
import { toast } from '@/shared/ui';

/** Lỗi 4xx là lỗi nghiệp vụ/quyền ⇒ không thử lại; lỗi mạng/5xx thử lại tối đa 2 lần. */
const retry = (count: number, e: unknown) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && count < 2;

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, retry, refetchOnWindowFocus: true }, mutations: { retry: false } },
    // Thao tác lỗi ⇒ toast thông điệp nghiệp vụ từ máy chủ (trừ khi mutation tự xử lý: meta.silent)
    mutationCache: new MutationCache({
      onError: (e, _v, _c, m) => {
        if (!m.meta?.silent) toast.error(errorMessage(e));
      },
      onSuccess: (_d, _v, _c, m) => {
        if (typeof m.meta?.success === 'string') toast.ok(m.meta.success);
      },
    }),
  });
}

/** Khoá không thuộc riêng người dùng nào (màn đăng nhập đọc trước khi có phiên) ⇒ giữ qua lần đổi phiên. */
const sharedKey = (k: readonly unknown[]) => k[0] === 'tenant' && k[1] === 'branding';

/**
 * Bỏ mọi dữ liệu của phiên trước (bootstrap, kết quả Tìm nhanh, hộp việc, danh sách…) — gọi khi một phiên mới bắt đầu
 * trên cùng tab (đăng nhập lại, có thể là người khác). Truy vấn đang chạy bị huỷ; chỉ giữ thương hiệu công ty.
 */
export function resetUserCache(qc: QueryClient) {
  qc.removeQueries({ predicate: (q) => !sharedKey(q.queryKey) });
  qc.getMutationCache().clear();
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { silent?: boolean; success?: string };
  }
}
